module.exports = __webpack_public_path__ + "static/media/  (53).d11ec5ff.jpg";